module.exports = __webpack_public_path__ + "static/media/offerbg.2d2f2e04.png";